import { Image } from 'expo-image';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

function TimelineLine({ backgroundColor }: { backgroundColor: string }) {
  return <View style={[styles.timelineLine, { backgroundColor }]} />;
}

function TimelineItem({
  active,
  title,
  isActiveToRight,
}: {
  active?: boolean;
  title?: string;
  isActiveToRight?: boolean;
}) {
  const backgroundColor = active ? tokens.colors.$success : tokens.colors.$blackOpacity04;

  return (
    <View>
      <View style={styles.timelineItemContent}>
        {active && (
          <TimelineLine
            backgroundColor={
              isActiveToRight ? tokens.colors.$blackOpacity04 : tokens.colors.$success
            }
          />
        )}
        <View style={styles.timelineItemDotContainer}>
          <View style={[styles.timelineDot, { backgroundColor }]} />
        </View>
        {active && (
          <TimelineLine
            backgroundColor={
              isActiveToRight ? tokens.colors.$success : tokens.colors.$blackOpacity04
            }
          />
        )}
      </View>
      <Text.Ui size="sm" weight="semibold" style={styles.timelineItemTitle}>
        {title ?? ' '}
      </Text.Ui>
    </View>
  );
}

function TimelineBirthday() {
  return (
    <View style={styles.timelineBirthdayContainer}>
      <TimelineLine backgroundColor={tokens.colors.$success} />
      <View style={styles.timelineBirthdayContent}>
        <Image source={require('./present.png')} style={styles.timelineBirthdayImage} />
        <Text.Ui size="sm" weight="semibold" style={styles.timelineBirthdayTitle}>
          Your Birthday
        </Text.Ui>
      </View>
      <TimelineLine backgroundColor={tokens.colors.$success} />
    </View>
  );
}

export function RedemptionAvailability() {
  return (
    <View style={styles.container}>
      <Text.Ui size="lg" weight="semibold">
        Redemption Availability
      </Text.Ui>
      <Text.Ui size="sm" style={styles.description}>
        You can redeem this reward online or in-restaurant during a{' '}
        <Text.Ui size="sm" weight="semibold">
          3-day window
        </Text.Ui>
        {' '}("Redemption Window"), starting the day before your birthday and ending the day after.
      </Text.Ui>
      <View style={styles.timelineContainer}>
        <TimelineItem />
        <TimelineItem active title="First Day" isActiveToRight />
        <TimelineBirthday />
        <TimelineItem active title="Last Day" />
        <TimelineItem />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
  },
  description: {
    marginTop: 8,
  },
  timelineContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    backgroundColor: tokens.colors.$blackOpacity04,
    borderRadius: 12,
    paddingVertical: 16,
    paddingHorizontal: 12,
    marginTop: 16,
  },
  timelineItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  timelineItemDotContainer: {
    padding: 6,
    backgroundColor: tokens.colors.$blackOpacity04,
    borderRadius: 8,
    marginVertical: 4,
    marginHorizontal: 4,
  },
  timelineDot: {
    width: 8,
    height: 8,
    borderRadius: 5,
  },
  timelineLine: {
    height: 1,
    flex: 1,
  },
  timelineItemTitle: {
    marginTop: 2,
    paddingHorizontal: 4,
  },
  timelineBirthdayContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
  },
  timelineBirthdayContent: {
    alignItems: 'center',
  },
  timelineBirthdayImage: {
    width: 46,
    height: 46,
  },
  timelineBirthdayTitle: {
    marginTop: 2,
  },
});
